// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__-mpHq","percent":"style__percent__JmO21","progressRing":"style__progressRing__4B0B5","circle":"style__circle__XIHcd","circleBg":"style__circleBg__gAnQL"};